import script from "./EmailTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailTemplates.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__